module.exports = __webpack_public_path__ + "static/media/55_000044.77edc18d.jpg";